import { WorkSheet, utils } from 'xlsx'

// AOS exports started prefixing a subset of columns with "[ZM] " / "[ZM]_"
// (Geotarget, Advertiser Website, Order_Type, Modification_Type). Strip it on the
// header row so both sheet_to_json shapes keep using the original column names.
const ZM_PREFIX = /^\[ZM\][ _]/

export default function normalizeHeaders(sheet: WorkSheet): WorkSheet {
  if (!sheet || !sheet['!ref']) return sheet

  const range = utils.decode_range(sheet['!ref'])
  const header_row = range.s.r
  const address = (c: number) => utils.encode_cell({ r: header_row, c })

  const original = new Set<string>()
  for (let c = range.s.c; c <= range.e.c; c++) {
    const cell = sheet[address(c)]
    if (cell && typeof cell.v === 'string') original.add(cell.v)
  }

  for (let c = range.s.c; c <= range.e.c; c++) {
    const cell = sheet[address(c)]
    if (cell && typeof cell.v === 'string') {
      const stripped = cell.v.replace(ZM_PREFIX, '')

      // Skip if a real column already owns the un-prefixed name, so we never
      // demote it to Geotarget_1 and break the parsers.
      if (stripped !== cell.v && !original.has(stripped)) {
        cell.v = stripped
        if (cell.w !== undefined) cell.w = stripped
        if (cell.h !== undefined) cell.h = stripped
        if (cell.r !== undefined) cell.r = `<t>${stripped}</t>`
      }
    }
  }

  return sheet
}
